import type { Reference, Resource } from '@medplum/fhirtypes'
import { z } from 'zod'
import { getReferenceString } from '#src/references.ts'

// https://docs.elationhealth.com/reference/metadata
export const metadataSchema = z.object({
  object_id: z.string().max(100).nullable().optional(),
  object_web_link: z.string().url().max(200).nullable().optional(),
  data: z.record(z.any()).nullable(),
})

export type Metadata = z.infer<typeof metadataSchema>
export const matchesFhirRef = <
  T extends { metadata?: Metadata | null | undefined },
>(
  elationObject: T,
  fhirRef: Reference | Resource
): boolean =>
  elationObject.metadata?.data?.fhirRef === getReferenceString(fhirRef)

export const addFhirRef = <
  T extends { metadata?: Metadata | null | undefined },
>(
  elationObject: T,
  fhirRef: Reference | Resource
): T => ({
  ...elationObject,
  metadata: {
    ...elationObject.metadata,
    data: {
      ...elationObject.metadata?.data,
      fhirRef: getReferenceString(fhirRef),
    },
  },
})
